import type { FC } from 'react';

// 8 颗外圈点按顺时针排列：左上 → 上中 → 右上 → 右中 → 右下 → 下中 → 左下 → 左中
// 每个位置的初始半径（角点大、边中点小，与原始 Figma 视觉对齐）
const RING_DOTS = [
  { cx: 2.28571, cy: 2.28571 },
  { cx: 7.99833, cy: 2.28544 },
  { cx: 13.7132, cy: 2.28544 },
  { cx: 13.7154, cy: 8.00056 },
  { cx: 13.7154, cy: 13.7134 },
  { cx: 7.99833, cy: 13.7151 },
  { cx: 2.28571, cy: 13.7134 },
  { cx: 2.28739, cy: 8.00028 },
] as const;
const BIG = 2.28571;
const SMALL = 1.14286;
// 顺时针 8 个位置的初始 r 值
const BASE_R = [BIG, SMALL, SMALL, BIG, BIG, SMALL, BIG, SMALL];
// 位置 0 经历的 r 序列：每帧接收前一位置的旧 r 值，即 BASE_R[(8 - k) % 8]
// 末尾补 BASE_R[0] 让 keyTime=1 有目标值，组成完整循环
const POS0_R_SEQ = [...Array.from({ length: 8 }, (_, k) => BASE_R[(8 - k) % 8]), BASE_R[0]];
const RING_VALUES = POS0_R_SEQ.join(';');
const RING_KEY_TIMES = Array.from({ length: 9 }, (_, k) => (k / 8).toFixed(3)).join(';');
// 3.2s 一圈：每帧 400ms，节奏舒缓
const RING_DUR = '3.2s';
const RING_FRAME_S = 0.4;

export const ProcessingDotsIcon: FC = () => (
  <svg width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {RING_DOTS.map((d, i) => (
      <circle key={`${d.cx}-${d.cy}`} cx={d.cx} cy={d.cy} fill="currentColor">
        <animate
          attributeName="r"
          values={RING_VALUES}
          keyTimes={RING_KEY_TIMES}
          dur={RING_DUR}
          // 共享同一段 values，begin 负偏移让 i 号位置从序列第 i 帧开始（顺时针轮换视觉）
          begin={`${-i * RING_FRAME_S}s`}
          repeatCount="indefinite"
        />
      </circle>
    ))}
    {/* 中心点静止 */}
    <circle cx="7.99833" cy="8.00028" r="1.14286" fill="currentColor" />
  </svg>
);
